import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from 'react-query';
import { InvalidateOptions, InvalidateQueryFilters } from 'react-query/types/core/types';

export type InvalidateArgument = string | InvalidateQueryFilters<any> | InvalidateOptions;

export interface IRequestMutationOptions extends UseMutationOptions<any, any, any, any> {
  invalidateArgs?: InvalidateArgument[];
  invalidateArgsOnError?: InvalidateArgument[];
}

const useRequestMutation = ({
  onError,
  onSuccess,
  invalidateArgs,
  invalidateArgsOnError,
  ...mutationOptions
}: IRequestMutationOptions): UseMutationResult<any> => {
  const queryClient = useQueryClient();

  const invalidateQueries = (args?: InvalidateArgument[]) => {
    if (args?.length || 0 >= 1) {
      args?.forEach((arg) => queryClient.invalidateQueries(arg as any));
    }
  };

  const mutation = useMutation({
    onError: (...args) => {
      invalidateQueries(invalidateArgsOnError);
      onError?.(...args);
    },

    onSuccess: (...args) => {
      invalidateQueries(invalidateArgs);
      onSuccess?.(...args);
    },

    ...mutationOptions,
  });

  return mutation as UseMutationResult<any>;
};

export default useRequestMutation;
